import { useAppDispatch } from "../../../redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Row from "./Row";
import TableHeader from "./tableHeader";
import Pagination from "../../pagination";
import {
  adminSurveyTablePageIndex,
  getAdminSurveyReport,
} from "../../../redux/reducer/surveyReportReducer";
import { Spinner } from "react-bootstrap";

const SurveyAdminFilterTable = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  /**
   * Get state variables from redux store.
   */
  const { surveysReport } = useSelector((state: any) => state);
  const { adminSurveysReportList, adminPageIndex, pageTotal } = surveysReport;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      await dispatch(getAdminSurveyReport());
    } finally {
      setLoading(false);
    }
  };

  /**
   * update survey report table pagination and refetch on page change.
   */
  const setPageIndex = (newpage: any) => {
    dispatch(adminSurveyTablePageIndex(newpage));
    fetchData();
  };

  return (
    <div className="container-box mb-3">
      <div className="survey-wrapper-box pt-0">
        <table className="table">
          <TableHeader />
          <tbody>
            {!loading &&
              adminSurveysReportList.map((report: any, key: any) => (
                <Row report={report} key={key} />
              ))}
          </tbody>
        </table>
        <div className="col-12 mt-2 mb-2">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                size="sm"
                className="ms-2 spinner-size"
              />
            </div>
          ) : (
            <Pagination
              onPageChange={setPageIndex}
              pageIndex={adminPageIndex}
              pageTotal={pageTotal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveyAdminFilterTable;
